import { SVGProps } from 'react';

const PC = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M9 4.25a.75.75 0 0 1 .75.75v14a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75V5A.75.75 0 0 1 3 4.25h6Zm13 4a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-.75.75h-4.25v1.5H20a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1 0-1.5h2.25v-1.5H12a.75.75 0 0 1-.75-.75V9a.75.75 0 0 1 .75-.75h10Zm-18.25 10h4.5V5.75h-4.5v12.5Zm1.5-2.24V16a.75.75 0 0 1 1.5 0v.01a.75.75 0 0 1-1.5 0Zm7.5-.76h8.5v-5.5h-8.5v5.5Zm-7.5-2.24V13a.75.75 0 0 1 1.5 0v.01a.75.75 0 0 1-1.5 0Z"
    />
  </svg>
);

export default PC;
